import React, { useRef } from 'react'
import { useTranslation } from 'react-i18next'
import { ActionChip, useOverlay } from '@fs/zion-ui'
import { useUsabilla, FallbackOverlay } from '@fs/zion-usabilla'
import { urlUtils } from '@fs/zion-memories/memories-authorized-use-only'
import { LogoFamilysearch } from '@fs/zion-icon'

export default function FeedbackButton() {
  const [t] = useTranslation()
  const buttonRef = useRef(null)
  const fallbackOverlay = useOverlay({ focusBackRef: buttonRef })

  const { open, handleMouseDown, handleKeyDown } = useUsabilla({
    url: urlUtils.usabillaUrl,
    buttonRef,
  })

  const handleClick = async () => {
    const opened = await open()
    if (!opened) {
      fallbackOverlay.open()
    }
  }

  return (
    <>
      {(fallbackOverlay.isOpen || fallbackOverlay.transitioning) && (
        <FallbackOverlay communityLink={urlUtils.communityLink} {...fallbackOverlay} />
      )}
      <ActionChip
        ref={buttonRef}
        emphasis="low"
        Icon={LogoFamilysearch}
        label={t('memories.subnav.feedback', 'Feedback')}
        onClick={handleClick}
        onMouseDown={handleMouseDown}
        onKeyDown={handleKeyDown}
      />
    </>
  )
}
